<div class="row mb22">
    <div class="col-12">
        <div class="fs11-text">
            <span class="superText">*</span>
            <span id="freshPassSection">{{properties.manage.RESTRICTIONS_APPLY_FULL_PROGRAM_TERMS_CONDITIONS}} <button
                    (click)="openTerms(userSubscriptionDetails, userInfo)"
                    (keydown.enter)="openTerms(userSubscriptionDetails, userInfo)" aria-label="here Restrictions apply. Full program Terms & Conditions"
                    class="links__action__default sub-termsunderline-text p0"
                    role="link">{{properties.manage.HERE}}</button>.</span>
        </div>
    </div>
</div>
